import { createFileRoute, Outlet } from '@tanstack/react-router';
import { SettingsFrame } from '@/features/settings/frame';

// S21–S26: the Settings title, the tab's lead and the tabs around the tab's route.
export const Route = createFileRoute('/_app/settings')({
  component: () => (
    <SettingsFrame>
      <Outlet />
    </SettingsFrame>
  ),
});
